<div class="life-insurance">
  <img src="./assets/img/icono-seguro.svg" alt="" role="decoration" />
  <h3 class="h-main h-main-medium">Tu vida en tu nuevo hogar</h3>
  <p class="info-text">
    Seguro que ya has imaginado cómo será tu vida en tu nuevo hogar. Y ahora, que estás muy cerca de conseguir tu
    hipoteca, es el momento de pensar en todos los detalles para que nada pueda fallar.
  </p>
  <p class="info-text">
    En Pibank no vinculamos nuesta hipoteca a ningún requisito, pero te ofrecemos el mejor seguro de vida con Caser
    Seguros. Para que tú y los tuyos conteís con la mejor protección.
  </p>
  <p class="info-text">¿Te gustaría solicitar más información sobre nuestros seguros de vida?</p>
  <div class="form-btn-group col-12 no-pd d-flex justify-content-end">
    <a class="btn btn-01" href="javascript:void(0)" (click)="cancel()">{{ 'Por ahora, no' | translate }}</a>
    <a class="btn btn-02" href="javascript:void(0)" (click)="accept()">{{ 'Si, quiero información' | translate }}</a>
  </div>

  @if (showError) {
    <p class="has-error">{{ 'error_page_err_generic' | translate }}</p>
  }
</div>
